import React from "react";
import Moment from "moment";

const infoTypes = {
  text: "text",
  date: "date",
};
export const OrderInfoDisplay = ({
  label,
  infoType = infoTypes.text,
  dateFormat = "DD MMM yyyy, dddd",
  info,
  infoFallback = "Not Found",
  containerProps = { className: "col-md-6" },
  hideOnEmpty = false,
}) => {
  let processedInfo = infoFallback;
  if (info) {
    if (infoType === infoTypes.date) {
      processedInfo = Moment(info).format(dateFormat);
    } else {
      processedInfo = info;
    }
  }
  return hideOnEmpty && !info ? (
    <></>
  ) : (
    <div {...containerProps}>
      <label className="font-weight-bold">{label}</label>
      <div className="mb-2">{processedInfo}</div>
    </div>
  );
};
